import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AudioPlayerProvider } from "./contexts/AudioPlayerContext";
import { AuthProvider } from "./contexts/AuthContext";
import Navbar from "./components/Navbar";
import AudioPlayer from "./components/AudioPlayer";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Store from "./pages/Store";
import Contact from "./pages/Contact";
import Licensing from "./pages/Licensing";
import CheckoutSuccess from "./pages/CheckoutSuccess";
import AdminLogin from "./pages/AdminLogin";
import Admin from "./pages/Admin";
import BeatDetail from "./pages/BeatDetail";
import Reviews from "./pages/Reviews";
import "./App.css";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AudioPlayerProvider>
          <div className="min-h-screen bg-background">
            <div className="noise-overlay" />
            <Navbar />
            <main className="pb-32">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/store" element={<Store />} />
                <Route path="/beat/:id" element={<BeatDetail />} />
                <Route path="/reviews" element={<Reviews />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/licensing" element={<Licensing />} />
                <Route path="/checkout/success" element={<CheckoutSuccess />} />
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin" element={<Admin />} />
              </Routes>
              <Footer />
            </main>
            <AudioPlayer />
            <Toaster position="top-right" />
          </div>
        </AudioPlayerProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
